import controller from './upload.controller';
import template from './upload.html';
import './upload.scss';
/**
 * @ngdoc component
 * @name upload
 * @description
 * The upload component of the app.
 *
 * @memberof upload
 */
export default {
  /**
   * The controller class for the component.
   * @type {UploadController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String} campaignId  ID of the campaign to be selected.
   */
  bindings: {
    campaignId: '@',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/upload/components/upload/upload.component.js